import { type AgsReportCountry } from '~/exportReport/exportReport.constants';
import { ExportReportType } from '~/exportReport/exportReportType';

export const isReportTypePolygon = (type: ExportReportType) => (
  type === ExportReportType.Polygon || type === ExportReportType.DriveTimePolygon
);

export const getReportSampleCenter = (country: AgsReportCountry) => {
  switch (country) {
    case 'can':
      // Montreal
      return {
        lat: 45.5088,
        lng: -73.5541,
      };
    case 'mex':
      // Tijuana
      return {
        lat: 32.5027,
        lng: -117.0037,
      };
    case 'usa':
    default:
      // Los Angeles
      return {
        lat: 34.0522,
        lng: -118.2437,
      };
  }
};
